// src/helpers/factories/menu/cardFactories/itemGroups/itemGroupsParentCombosFactory.ts
var itemGroupsParentCombosFactoryCore = (combos, itemGroupParentComboIds) => Object.values(itemGroupParentComboIds).map((comboId) => {
  const combo = combos[comboId];
  if (combo) {
    return {
      id: comboId,
      title: combo.name
    };
  } else
    return null;
}).filter((value) => value !== null);

export { itemGroupsParentCombosFactoryCore };
